import { render, staticRenderFns } from "./PriceDetail.vue?vue&type=template&id=7e787039&scoped=true&"
import script from "./PriceDetail.vue?vue&type=script&lang=js&"
export * from "./PriceDetail.vue?vue&type=script&lang=js&"
import style0 from "./PriceDetail.vue?vue&type=style&index=0&id=7e787039&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e787039",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e787039')) {
      api.createRecord('7e787039', component.options)
    } else {
      api.reload('7e787039', component.options)
    }
    module.hot.accept("./PriceDetail.vue?vue&type=template&id=7e787039&scoped=true&", function () {
      api.rerender('7e787039', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/price/PriceDetail.vue"
export default component.exports